import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getGameDayKey} from '../../utils/date/getGameDayKey';
import {selectServerTimeDelta} from '../../redux/reducers/privateStateReducer/selectors';

// Пересчет ключа текущих суток раз в минуту: дешево и достаточно, чтобы бейдж
// зажегся в течение минуты после смены суток
const DAY_KEY_RECHECK_INTERVAL_MS = 60 * 1000;

/**
 * Доступна ли сегодня повторяющаяся ежедневная награда (игровые сутки,
 * см. getGameDayKey): двойная (x2) за первый рейтинговый матч дня или
 * награда за вход — lastRewardAt — момент последнего получения из профиля
 * (ISO-строка/Date/timestamp или null). Ключ текущего дня — состояние с
 * периодическим пересчетом: страница может жить открытой сутками без
 * перезагрузки, и бейдж должен сам зажечься после полуночи, а не только
 * после свежего /me.
 *
 * Время берется СЕРВЕРНОЕ (Date.now() + поправка из /api/time): у игрока могут
 * быть неверно выставлены часы, и тогда расчет по часам устройства попадал не
 * в те игровые сутки — награда считалась доступной, хотя уже была получена.
 */
export const useIsDailyDoubleRewardAvailable = (lastRewardAt) => {
  const serverTimeDelta = useSelector(selectServerTimeDelta);
  const [todayKey, setTodayKey] = useState(() => getGameDayKey(Date.now() + serverTimeDelta));

  useEffect(() => {
    // Пересчет сразу на изменение поправки, а не только по таймеру: /api/time
    // отвечает уже после первого рендера, и до его ответа ключ посчитан по
    // часам устройства
    const recalculate = () => setTodayKey(getGameDayKey(Date.now() + serverTimeDelta));
    recalculate();

    // setState с тем же значением не вызывает ре-рендер — тикать раз в
    // минуту безопасно, перерисовка случится только на смене суток
    const intervalId = setInterval(recalculate, DAY_KEY_RECHECK_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [serverTimeDelta]);

  return getGameDayKey(lastRewardAt) !== todayKey;
};
